const updateRoamingCountries = async (container: HTMLElement, value: string, euCountry: string | undefined) => {
  const spinner = document.querySelector<HTMLElement>("#loading-spinner");
  const defaultText = document.querySelector<HTMLElement>("#defaulttext");
  const euText = document.querySelector<HTMLElement>("#eutext");
  const countryText = document.querySelector<HTMLElement>("#countrytext");
  const countryErrorText = document.querySelector<HTMLElement>("#country-error-text");

  const notFoundMessage = "Vi fant ikke priser for valgt land.";
  const requestFailedMessage = "Vi klarte ikke hente priser akkurat nå. Prøv igjen senere.";

  if (!spinner || !defaultText || !euText || !countryText || !countryErrorText) {
    return;
  }

  const hideErrorText = () => {
    countryErrorText.textContent = "";
    countryErrorText.classList.add("hidden");
  };

  const showErrorText = (message: string) => {
    countryErrorText.textContent = message;
    countryErrorText.classList.remove("hidden");
  };

  const showDefaultText = () => {
    container.innerHTML = "";
    spinner.classList.add("hidden");
    defaultText.classList.remove("hidden");
    euText.classList.add("hidden");
    countryText.classList.add("hidden");
  };

  spinner.classList.remove("hidden");
  hideErrorText();

  const uri = new URL("/api/roamingcountries/countryinfo", window.location.href);

  if (container.dataset.addVat) {
    uri.searchParams.append("addVat", container.dataset.addVat.toLowerCase());
  }

  if (value) {
    uri.searchParams.append("contentid", value);
  }

  try {
    const response = await fetch(uri.toString());
    if (response.status === 404) {
      showDefaultText();
      showErrorText(notFoundMessage);
      return;
    }

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    const html = await response.text();
    if (!html.trim()) {
      showDefaultText();
      showErrorText(notFoundMessage);
      return;
    }

    container.innerHTML = html;
    spinner.classList.add("hidden");
    defaultText.classList.add("hidden");
    hideErrorText();

    if (euCountry?.toLowerCase() === "true") {
      countryText.classList.add("hidden");
      euText.classList.remove("hidden");
    } else {
      euText.classList.add("hidden");
      countryText.classList.remove("hidden");
    }
  } catch (e) {
    void e;
    showDefaultText();
    showErrorText(requestFailedMessage);
  }
};

interface DropDownChangesDetails {
  value: string;
  text: string;
  dataset: DOMStringMap;
}

const initFastLinks = () => {
  const roamingPriceValue = document.querySelector<HTMLInputElement>("#roaming-price-dropdown");
  if (!roamingPriceValue) return;
  const container = document.querySelector<HTMLElement>("#country-container");
  if (!container) return;

  roamingPriceValue.addEventListener("selected", (event) => {
    const detail = (event as CustomEvent<DropDownChangesDetails>).detail;
    void updateRoamingCountries(container, detail.value, detail.dataset.eu);
  });

  const fastLinks = document.querySelector<HTMLElement>(".roaming-fast-links");
  if (!fastLinks) return;

  fastLinks.childNodes.forEach((el) => {
    const dropdown = roamingPriceValue;
    el.addEventListener("click", () => {
      dropdown.dispatchEvent(
        new CustomEvent("setSelected", {
          detail: { query: (el as HTMLButtonElement).value },
        }),
      );
    });
  });
};

initFastLinks();
